import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/arrow_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-66630659"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "select-group-name"
}
const _hoisted_2 = ["onClick", "innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "select-line"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { t } from '@/plugins/i18n'
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { cloneDeep } from 'lodash'
import { useSite, isJA, isKO, isEN } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['value', 'list', 'type', 'country', 'rowKey', 'width', 'placeholder', 'disabled', 'dontSelect'],
  emits: ['update:value', 'change'],
  setup(__props, { emit }) {

const props = __props


const visible = ref(false)
const keyword = ref('')
const getList = (country: any) => {
  let list: any = []
  if (props.country === '2279' && isJA()) {
    list.push({
      label: '',
      children: [
        ...country.map((i: any) => {
          return {
            ...i,
            // 如果是日本站取ja
            mergeName: i.nameJa
          }
        })
      ]
    })
  } else {
    // abc排序
    country.forEach((item: any) => {
      let isHave = false
      list.forEach((temp: any) => {
        if (temp.label === (item.nameEn && item.nameEn[0])) {
          isHave = true
          temp.children.push({
            ...item,
            mergeName: getMargeName(item)
          })
        }
      })
      if (!isHave) {
        list.push({
          label: (item.nameEn && item.nameEn[0]),
          children: [
            {
              ...item,
              mergeName: getMargeName(item)
            }
          ]
        })
      }
    })
    list = list.sort((a: any, b: any) => a.label.localeCompare(b.label))
  }
  return list
}
const getMargeName = (item: any) => {
  return (item.nameEn || '') + (
    (isJA()
      ? ' ' + (item.nameJa || '')
      : isKO()
        ? ' ' + (item.nameKr || '')
        : ''))
}
const countryList = ref([])
const copyList: any = ref([]) // 原始数据

let activeItem = {}
const oldValue = computed(() => {
  let value = ''
  copyList.value.forEach((item: any) => {
    item.children.forEach((temp: any) => {
      if (temp[props.rowKey] === props.value) {
        activeItem = temp
        value = temp.mergeName
        keyword.value = temp.mergeName
      }
    })
  })
  return value || props.value
})
watch(() => [props.value, props.list], (newValue: any) => {
  countryList.value = getList(props.list || [])
  copyList.value = cloneDeep(countryList.value)
  keyword.value = props.value
}, {
  deep: true,
  immediate: true
})
const sortSelectInput = ref()
const clickFn = (e: any) => {
  if (!visible.value) return
  const ele1 = document.querySelector('.sort-select-input')
  const ele2 = document.querySelector('.sort-select-tool')
  if (isChildOf(e.target, sortSelectInput.value.ref) || isChildOf(e.target, ele2) || sortSelectInput.value.ref === e.target) {
    visible.value = true
  } else {
    visible.value = false
    keyword.value = oldValue.value
    countryList.value = cloneDeep(copyList.value)
  }
}
onMounted(() => {
  window.addEventListener('mouseup', clickFn)
})
onUnmounted(() => {
  window.removeEventListener('mouseup', clickFn)
})
const showTool = () => {
  keyword.value = ''

  setTimeout(() => {
    visible.value = true
  }, 200)
}
const choose = (temp: any) => {
  if (temp[props.rowKey] !== props.value) {
    emit('change', temp)
  }
  activeItem = temp
  emit('update:value', temp[props.rowKey])
  visible.value = false
  keyword.value = oldValue.value
  countryList.value = cloneDeep(copyList.value)
}
// 输入时修改list
const changeWord = () => {
  const list: any = []
  copyList.value.forEach((item: any) => {
    const obj: any = {
      label: item.label,
      children: []
    }
    item.children.forEach((temp: any) => {
      if (new RegExp(keyword.value, 'ig').test(temp.mergeName)) {
        obj.children.push({
          ...temp,
          mergeName: temp.mergeName.replace(new RegExp('(' + keyword.value + ')', 'ig'), '<i>$1</i>')
        })
      }
    })
    if (obj.children.length > 0) {
      list.push(obj)
    }
  })
  countryList.value = list
}
const isChildOf = (child: any, parent: any) => {
  if (child && parent) {
    let parentNode = child.parentNode
    while (parentNode) {
      if (parent === parentNode) {
        return true
      }
      parentNode = parentNode.parentNode
    }
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "sort-select rel",
    style: _normalizeStyle({ width: __props.width + 'px' })
  }, [
    _createVNode(_component_el_tooltip, {
      placement: "bottom",
      effect: "light",
      visible: visible.value,
      "popper-class": "sort-select-tool",
      offset: 4,
      ref: (_value, _refs) => {
        _refs['sortSelectTool'] = _value
      }
    }, {
      content: _withCtx(() => [
        (countryList.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "select-content",
              style: _normalizeStyle({ width: __props.width + 'px' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "select-group",
                  key: index
                }, [
                  (item.label)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.label), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (temp, indexKey) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([{ active: __props.value === temp[__props.rowKey] }, 'select-group-item']),
                      key: indexKey,
                      onClick: ($event: any) => (choose(temp)),
                      innerHTML: temp.mergeName
                    }, null, 10, _hoisted_2))
                  }), 128)),
                  (copyList.value.length > index + 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 4))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "empty",
              style: _normalizeStyle({ width: __props.width + 'px' })
            }, _toDisplayString(_unref(t)('无相关搜索结果')), 5))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: _unref(oldValue) || __props.placeholder,
          onFocus: showTool,
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          style: _normalizeStyle({ width: __props.width + 'px' }),
          class: "sort-select-input",
          onInput: changeWord,
          disabled: !__props.list || __props.list.length === 0 || __props.disabled || __props.dontSelect,
          ref: (_value, _refs) => {
            _refs['sortSelectInput'] = _value
            sortSelectInput.value = _value
          },
          autoComplete: "off"
        }, null, 8, ["placeholder", "modelValue", "style", "disabled"])
      ]),
      _: 1
    }, 8, ["visible"]),
    (!__props.dontSelect)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          alt: "",
          class: _normalizeClass([{ active: visible.value }, 'arrow-icon abs'])
        }, null, 2))
      : _createCommentVNode("", true)
  ], 4))
}
}

})